import { useState } from "react";
import { ShieldPlus, Car } from "lucide-react";
import Wizard from "./Wizard";
import MotorUpload from "./MotorUpload";

export default function Home() {
  const [mode, setMode] = useState("health");

  const pill = (active) =>
    `inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
      active ? "accent-bg text-white" : "text-secondary-brand hover:text-primary-brand"
    }`;

  return (
    <>
      <div className="fixed top-3 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1 bg-surface border border-subtle rounded-full p-1 shadow-sm">
        <button type="button" onClick={() => setMode("health")} className={pill(mode === "health")} data-testid="mode-health">
          <ShieldPlus size={15} /> Health
        </button>
        <button type="button" onClick={() => setMode("motor")} className={pill(mode === "motor")} data-testid="mode-motor">
          <Car size={15} /> Motor
        </button>
      </div>

      {mode === "health" ? <Wizard /> : <MotorUpload />}
    </>
  );
}
